<template>
  <div id="content">
    <div id="video">
    <div class="video">
      <div class="videolist le">
        
      <a v-for="v in video" :key="v.id" class="video le  mar20 "  :href="'/#/videodetail/' + v.id" target="_blank">
        <span class="video-img le">
          <span class="img le">
            <img :src="v.image" >
          </span>
          <span class=" btn-play  le"></span>
        </span>
        <span  v-if="$i18n.locale=='en'"   class="video-title le"> {{v.name_en}}     </span>
        <span  v-else    class="video-title le"> {{v.name}}     </span>
        </a>
          </div>
    </div>
  </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  components: {},
  name: "Video",
  data() {
    return {
      video: []
    };
  },
  mounted() {
    // 使用
    const params = { }; // 参数
    fetch.post("/api/ApiVideo/GetAllVideoList", params).then(
      (res) => {
        this.video = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  }
};
</script>

<style>
#video {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  height: auto;
}

.video {
  width: 1190px;
  overflow: hidden;
  margin: 5px auto auto;
}
/*videolist-top01*/
.videolist-top01{width:100%;height: auto;background: #fff;}
.videolist-top01 .videolist-top01-wrapper{width:1190px;height: auto;margin: 0 auto;}
.videolist-top01 .videolist-top01-wrapper .videolist{width:100%;height: auto;margin-top: 80px;}
.videolist {width:100%}
.videolist .video{display:block;width:31.5%;height: auto;margin-bottom: 30px;}
.videolist .video:hover>.video-title{color:#000;}
.videolist .video .video-img{width:100%;height: 300px;background-color: #f2f3f7;position: relative;border-radius: 10px;}
.videolist .video .video-img .img{width:100%;height: 300px; overflow: hidden;}
.videolist .video .video-img img{width:100%;height: 300px;border-radius: 10px;transition: .4s all;overflow:hidden;}
.videolist .video .video-img .btn-play{width:100%;height: 300px;background-color: rgba(0,0,0,0.2);background-image: url(./images/icn-004.png);background-repeat: no-repeat;background-size: 95px 95px;background-position: center;border-radius: 10px;position: absolute;top: 0;left: 0;transition: .4s all;}
.videolist .video .video-img .btn-news{width:100%;height: 300px;background-color: rgba(0,0,0,0);box-shadow: 0 0 16px rgba(0,0,0,0.07); border-radius: 10px;position: absolute;top: 0;left: 0;transition: .4s all;}
.videolist .video .video-img:hover> .img img{transform:scale(1.1);}

.videolist .video .video-img .btn-play:hover{background-color: rgba(0,0,0,0.5);}
.videolist .video .video-img .btn-news:hover{box-shadow: 0 0 16px rgba(147,209,19,0.5);}
.videolist .video .video-title{width:100%;height: 30px;line-height: 30px;overflow: hidden;font-size: 16px;color:#666666;text-align: left;font-weight: bold;margin-top: 20px;}
.videolist .video .video-time{width:100%;height: 78px;line-height: 26px;overflow: hidden;font-size: 14px;color:#666;text-align: left;text-indent: 2em;text-overflow: ellipsis;}
.videolist .mar20{margin-right:20px;}
</style>



// WEBPACK FOOTER //
// src/Video.vue